import {
  FormControlLabel,
  MenuItem,
  Pagination,
  Paper,
  Select,
} from "@mui/material";
import SearchComponent from "components/SearchComponent";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import { getWeekDate } from "lib/date";
import {
  DEFAULT_QUERY_LIMIT,
  orderStatusOptions,
  paymentStatusOption,
  regionOption,
} from "lib/global";
// import { orderStatusOptions } from "models/boxesModel";
import CustomLink from "components/CustomLink";
import CustomTab from "components/CustomTab";
import { CustomStatusBadge } from "components/StatusBadge";
import PaperButton from "components/buttons/PaperButton";
import { formatArray } from "lib/arrayObject";
import { getWeekDaysByWeekNumber } from "lib/date";
import { DEFAULT_ELEVATION } from "lib/global";
import { getAllRegions } from "models/regionModel";
import { downloadCsv, getAllOrders } from "models/weeklySlotsModel";
import moment from "moment";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory } from "react-router-dom";
import { openLoading } from "store/reducers/tools";
import OrderTable from "./OrderTable";

const tabs = [
  { label: "All Orders", tab: "all" },
  { label: "Subscription Orders", tab: "sub" },
  { label: "One-off Orders", tab: "one_off" },
];

export default function OrderComponent() {
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("all");
  const [searchWord, setSearchWord] = useState("");
  const [payment, setPayment] = useState("all");
  const [region, setRegion] = useState("all");
  const [searchType, setSearchType] = useState("all");
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  // const [pies, setPies] = useState([]);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [regRes, setRegRes] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  // const [csvHeaders, setCsvHeaders] = useState([]);
  const [sortKey, setSortKey] = useState({});

  const handleSortKey = (columnIndex = 0, column = {}) => {
    setSortKey((s = {}) => ({
      index: columnIndex,
      column: column,
      asc: s?.index === columnIndex ? !Boolean(s?.asc ?? false) : false,
    }));
  };

  // const headers = [
  //   { label: "ID", key: "id", hide: false },
  //   { label: "Name", key: "name", hide: false },
  //   { label: "Address", key: "address", hide: false },
  //   { label: "Region", key: "region", hide: false },
  //   { label: "Post Code", key: "post_code", hide: false },
  //   { label: "Email", key: "email", hide: false },
  //   { label: "Phone Number", key: "phone", hide: false },
  //   { label: "Company Name", key: "company_name", hide: false },
  //   { label: "Delivery Note", key: "delivery_note", hide: false },
  //   { label: "Stripe ID", key: "stripe_id", hide: false },
  //   { label: "Payment Status", key: "payment", hide: false },
  //   { label: "Voucher Code", key: "voucher_code", hide: false },
  //   { label: "Dispatch Date", key: "dispatch_date", hide: false },
  //   { label: "Status", key: "status", hide: false },
  //   { label: "Created", key: "created", hide: true },
  //   {
  //     label: "Box Type",
  //     key: "box_type",
  //     // hide: activeTab.tab === "all" ? false : true,
  //     hide: true,
  //   },
  // ];

  const handleSearchWord = (e) => {
    setSearchWord(e.target.value.trim().replace(/[^A-Za-z0-9@. ]/g, ""));
  };

  const handlePagination = (e, v) => {
    setPageNum(v);
  };

  const loadData = () => {
    openLoading(true);
    getAllOrders({
      data: {
        limit: DEFAULT_QUERY_LIMIT,
        pageNum,
        searchType,
        searchWord,
        status,
        payment,
        region,
        dateRange,
        startDate,
        endDate,
        box_type: activeTab?.tab ?? true,
        sortKey,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        const orders = formatArray(res?.data).map((order) => {
          const reg = regRes?.filter(
            (item, index, self) => item?.postcode === order?.address?.postcode
          );
          return {
            ...order,
            region: reg?.[0]?.region,
          };
        });
        setData(orders);
        setTotalPageCount(Math.ceil(res?.totalCount / DEFAULT_QUERY_LIMIT));
        if (
          Math.ceil(res?.totalCount / DEFAULT_QUERY_LIMIT) &&
          Math.ceil(res?.totalCount / DEFAULT_QUERY_LIMIT) < pageNum
        ) {
          setPageNum(Math.ceil(res?.totalCount / DEFAULT_QUERY_LIMIT));
        }
      },
    });
  };

  const loadRegRes = () => {
    openLoading(true);
    getAllRegions({
      onFinish: (res, err) => {
        openLoading(false);
        setRegRes(res);
      },
    });
  };

  // const loadFlavours = () => {
  //   getPies({
  //     onFinish: (res, err) => {
  //       if (res === false) {
  //         if (!res && err?.message) {
  //           enqueueSnackbar(err?.message, { variant: "warning" });
  //         } else {
  //           enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
  //         }
  //         return;
  //       }
  //       setPies(res);
  //     },
  //   });
  // };

  // const orders = () => {
  //   const exportData = (exportData = data?.map((row, key) => {
  //     const csvData = {
  //       ...row,
  //       created: moment(row.created_at).format("DD/MM/YYYY"),
  //       // box_type: row?.box_type ? "Sub" : "One Off",
  //       address: row?.address?.label ?? "",
  //       region: row?.address?.region ?? "",
  //       post_code: row?.address?.postcode ?? "",
  //       company_name: row?.company_name ?? row?.other?.company_name ?? "",
  //       dispatch_date: getWeekDaysByWeekNumber({
  //         weekNumber: row?.week_next_num ?? row?.week_num,
  //         addDay: row?.week_day - 1,
  //         yearNumber: row.week_year,
  //       }),
  //       payment: paymentStatusOption.find(
  //         (item) => item.id === (row?.paid ?? "0")
  //       )?.label,
  //       status: orderStatusOptions.find(
  //         (item) => item.id === (row?.status ?? "0")
  //       )?.label,
  //       stripe_id: row?.payment_intent?.id,
  //       cut_off_date: row?.prev_slot_id
  //         ? getWeekDaysByWeekNumber({
  //             weekNumber: (row?.week_next_num ?? row?.week_num) - 2,
  //             addDay: 6,
  //             yearNumber: row.week_year,
  //           })
  //         : moment(row?.created_at).format("ddd DD MM"),
  //     };

  //     const rowPies = groupBy(
  //       formatArray(row?.pies)?.filter((pie) => pie),
  //       "id"
  //     );
  //     const piesData = Object.keys(rowPies).reduce(
  //       (ret, pieId) => ({
  //         ...ret,
  //         [pieId.toString()]: rowPies?.[pieId]?.length,
  //       }),
  //       {}
  //     );

  //     return { ...csvData, ...piesData };
  //   }));

  //   return exportData.map((item) => {
  //     switch (activeTab.tab) {
  //       case "all":
  //         return item;
  //       case "sub":
  //         const { box_type, ...newItem } = item;
  //         return newItem;
  //       case "one_off":
  //         const { box_type: box_type_oo, cut_off_date, ...newItemOO } = item;
  //         return newItemOO;
  //       default:
  //         return item;
  //     }
  //   });
  // };

  const handleView = (row = {}, valueIndex) => {
    history.push(`/order/${row?.id ?? ""}`);
  };

  const handleNewWindowView = (row = {}, valueIndex) => {
    window.open(`/order/${row?.id ?? ""}`, "_blank");
  };

  const handleExportCsv = async () => {
    openLoading(true);
    downloadCsv({
      data: {
        searchType,
        searchWord,
        status,
        payment,
        region,
        dateRange,
        startDate,
        endDate,
        box_type: activeTab?.tab ?? true,
        sortKey,
      },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
        }
        // Create a Blob from the CSV data
        const blob = new Blob([res], { type: "text/csv" });

        // Create a temporary URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element for initiating the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${activeTab?.label ?? "Orders"}.csv`);
        link.click();
      },
    });
  };

  useEffect(() => {
    // loadFlavours();
    loadRegRes();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, [
    searchWord,
    status,
    payment,
    region,
    dateRange,
    activeTab,
    pageNum,
    sortKey,
  ]);

  // useEffect(() => {
  // const piesHeader = pies.reduce(
  //   (ret, cur) => [
  //     ...ret,
  //     { label: cur?.name, key: cur.id.toString(), hide: false },
  //   ],
  //   []
  // );
  // pies.map((item, index) =>
  //   headers.push({ label: item?.name, key: `pie${item?.id}`, hide: false })
  // );
  // setCsvHeaders((s = []) => [...headers, ...piesHeader]);
  //eslint-disable-next-line
  // }, [pies]);

  return (
    <div>
      <div className="flex justify-between mb-4 flex-wrap">
        <div className="flex flex-wrap">
          <SearchComponent
            searchWord={searchWord}
            placeholder="Search Order"
            searchType={searchType}
            onKeyDown={(e) => handleSearchWord(e)}
            onBlur={handleSearchWord}
            onChange={(e) => {
              setSearchType(e.target.value);
              // setSearchWord("");
            }}
            onChangeSearchWord={handleSearchWord}
          />
          <FormControlLabel
            className="my-1"
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Status :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                {orderStatusOptions?.map((item) => (
                  <MenuItem value={item?.id} key={item?.id}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
          <FormControlLabel
            className="my-1"
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap pl-3"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Payment :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={payment}
                onChange={(e) => setPayment(e.target.value)}
              >
                <MenuItem value="all">All</MenuItem>
                {paymentStatusOption?.map((item) => (
                  <MenuItem value={item?.id} key={item?.id}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
          <FormControlLabel
            className="my-1"
            value="start"
            label={
              <CustomText
                className="whitespace-nowrap pl-3"
                variant="body2"
                color="secondary"
                bold={true}
              >
                Region :&nbsp;
              </CustomText>
            }
            labelPlacement="start"
            control={
              <Select
                size="small"
                sx={{ background: "#fff", width: 160 }}
                value={region}
                onChange={(e) => {
                  setRegion(e.target.value);
                }}
              >
                <MenuItem value="all">All</MenuItem>
                {regionOption?.map((item) => (
                  <MenuItem value={item?.label} key={item?.id}>
                    {item?.label ?? ""}
                  </MenuItem>
                ))}
              </Select>
            }
          />
        </div>
        <FormControlLabel
          className="my-1 z-10"
          sx={{ marginRight: 0 }}
          label={
            <CustomText
              className="whitespace-nowrap"
              variant="body2"
              color="secondary"
              bold={true}
            >
              Date :&nbsp;
            </CustomText>
          }
          labelPlacement="start"
          control={
            <DatePicker
              className="px-2 py-1 border rounded border-white-gray"
              selectsRange={true}
              startDate={startDate}
              dateFormat={"dd MMM"}
              endDate={endDate}
              onChange={(update) => {
                setDateRange(update);
              }}
              isClearable={true}
            />
          }
        />
      </div>

      <div className="mb-0.5">
        <div className="flex justify-between items-center">
          <CustomTab
            tabs={tabs}
            activeTab={activeTab}
            onClick={(tab) => setActiveTab(tab)}
          />

          {/* <ExportReactCSV
            csvHeaders={csvHeaders.filter((item) => !item.hide)}
            csvData={handleExportCsv()}
            fileName={`${activeTab?.label ?? "Orders"}.csv`}
          /> */}

          <CustomText
            className="cursor-pointer"
            color="secondary"
            bold
            onClick={handleExportCsv}
          >
            EXPORT LIST
          </CustomText>
        </div>
      </div>

      <Paper elevation={DEFAULT_ELEVATION}>
        <OrderTable
          height={650}
          data={data}
          pageCount={50}
          toolbar={false}
          columns={[
            {
              label: "ID",
              selector: "id",
              cell: (row, rowIndex) => (
                <CustomLink to={`/order/${row?.id ?? ""}`}>
                  <CustomText
                    variant="text"
                    color="primary"
                    // onClick={() => handleView(row, rowIndex)}
                    // onContextMenu={() => handleNewWindowView(row, rowIndex)}
                  >
                    {row?.id}
                  </CustomText>
                </CustomLink>
              ),
            },
            {
              label: "CREATED",
              selector: "created_at",
              sortValue: (row) => moment(row?.created_at).unix(),
              cell: (row) => moment(row.created_at).format("DD/MM/YY"),
            },
            ...[
              ...(activeTab.tab === "all"
                ? [
                    {
                      label: "ORDER TYPE",
                      selector: "box_type",
                      // sortValue: (row) => moment(row?.created_at).unix(),
                      cell: (row) => (row.box_type ? "Sub" : "One Off"),
                    },
                  ]
                : []),
            ],
            {
              label: "CUSTOMER",
              selector: "name",
            },
            {
              label: "ADDRESS",
              selector: "address",
              sortValue: (row) => row?.address?.label ?? "",
              cell: (row) => row?.address?.label ?? "",
            },
            {
              label: "REGION",
              selector: "region",
              sortValue: (row) => row?.region ?? row?.address?.region ?? "",
              cell: (row) => row?.region ?? row?.address?.region ?? "",
            },
            {
              label: "DISPATCH DATE",
              selector: "dispatch_date",
              sortValue: (row) =>
                getWeekDate({
                  weekNumber: row?.week_next_num ?? row?.week_num,
                  addDay: row?.week_day - 1,
                  yearNumber: row.week_year,
                }).unix(),
              cell: (row) =>
                getWeekDaysByWeekNumber({
                  weekNumber: row?.week_next_num ?? row?.week_num,
                  addDay: row?.week_day - 1,
                  yearNumber: row.week_year,
                }),
            },
            ...[
              ...(activeTab.tab !== "one_off"
                ? [
                    {
                      label: "CUT-OFF DATE",
                      selector: "cut_off_date",
                      sortValue: (row) =>
                        row?.prev_slot_id
                          ? getWeekDate({
                              weekNumber:
                                (row?.week_next_num ?? row?.week_num) - 2,
                              addDay: 6,
                              yearNumber: row.week_year,
                            }).unix()
                          : moment(row?.created_at).unix(),
                      cell: (row) =>
                        row?.prev_slot_id
                          ? getWeekDaysByWeekNumber({
                              weekNumber:
                                (row?.week_next_num ?? row?.week_num) - 2,
                              addDay: 6,
                              yearNumber: row.week_year,
                            })
                          : moment(row?.created_at).format("DD/MM/YY"),
                    },
                  ]
                : []),
            ],
            {
              label: "PAYMENT",
              selector: "payment",
              sortValue: (row) =>
                paymentStatusOption.find(
                  (item) => item.id === (row?.paid ?? "0")
                )?.label ?? "",
              cell: (row) => (
                <div className="flex items-center">
                  <CustomStatusBadge
                    size="body2"
                    text={
                      paymentStatusOption.find(
                        (item) => item.id === (row?.paid ?? "0")
                      )?.label
                    }
                    variant={
                      paymentStatusOption.find(
                        (item) => item.id === (row?.paid ?? "0")
                      )?.variant
                    }
                  />
                </div>
              ),
            },
            {
              label: "STATUS",
              selector: "status",
              sortValue: (row) =>
                orderStatusOptions.find(
                  (item) =>
                    item.id === (row?.tracking_info ? "1" : row?.status ?? "0")
                )?.label,
              cell: (row) => (
                <div className="flex items-center">
                  <CustomStatusBadge
                    size="body2"
                    text={
                      orderStatusOptions.find(
                        (item) => item.id === (row?.status ?? "0")
                      )?.label
                    }
                    variant={
                      orderStatusOptions.find(
                        (item) => item.id === (row?.status ?? "0")
                      )?.variant
                    }
                  />
                </div>
              ),
            },
            {
              label: "",
              selector: "actions",
              cell: (row, rowIndex) => (
                <CustomLink to={`/order/${row?.id ?? ""}`}>
                  <PaperButton
                    variant="text"
                    color="primary"
                    onClick={() => handleView(row, rowIndex)}
                    onContextMenu={() => handleNewWindowView(row, rowIndex)}
                  >
                    View Order
                  </PaperButton>
                </CustomLink>
              ),
            },
          ]}
          sortKey={sortKey}
          onSortChange={handleSortKey}
        />

        {totalPageCount > 1 ? (
          <div className="py-3 flex justify-center">
            <Pagination
              page={pageNum}
              count={totalPageCount}
              onChange={handlePagination}
              variant="contained"
              shape="rounded"
              color="primary"
            />
          </div>
        ) : null}
      </Paper>
    </div>
  );
}
